<template>
  <div>
    <slot v-if="isLoading" />
    <ul
      data-cy-id="header-menu"
      :class="['HeaderCount-container',{'is-notLoggedIn': !isLoggedIn}]"
    >
      <li v-if="!isAdminPage">
        <notifications />
      </li>
      <li
        v-if="isLoggedIn"
        class="subnav UserLoggedIn"
        @mouseenter="handleMouseEvent('show')"
        @mouseleave="handleMouseEvent('hide')"
      >
        <div @click.capture="handleShowMenu">
          <span class="far fa-user-circle UserIcon" />
          <div class="userDetails">
            <span
              v-if="firstname"
              class="name"
            >{{ firstname }}</span>
            <span
              v-else
              class="name"
            >Welcome</span>
            <span class="far fa-angle-down UserMenu" />
            <LinearProgressBar :percentage="profile_completion" />
          </div>
          <ul
            v-show="showUserMenu"
            class="Nav-hasSubLinks Nav-itemSubNav"
          >
            <li
              v-if="isAdmin"
              class="Nav-item"
            >
              <a
                class="Nav-link"
                href="/admin/vue"
              >Admin</a>
            </li>
            <li class="Nav-item">
              <a
                class="Nav-link"
                href="/dashboard/my-hub"
              >My Hub</a>
            </li>
            <li class="Nav-item">
              <a
                class="Nav-link"
                href="/dashboard/saved-items/saved-jobs"
              >Saved Items</a>
            </li>
            <li class="Nav-item">
              <a
                class="Nav-link"
                href="/dashboard/my-reviews/"
              >My Reviews</a>
            </li>
            <li class="Nav-item">
              <a
                class="Nav-link"
                href="/dashboard/contact-preferences/"
              >Contact Preferences</a>
            </li>
            <li class="Nav-item">
              <a
                class="Nav-link"
                href="/dashboard/personal-information/basic-info"
              >Personal Info</a>
            </li>
            <li class="Nav-item">
              <a
                class="Nav-link"
                href="/dashboard/data-security/"
              >Data & Security</a>
            </li>
            <li
              class="Nav-item"
              @click.prevent="logout"
            >
              <a
                class="Nav-link post-to-logout-link"
                href="#"
              >Logout</a>
            </li>
          </ul>
        </div>
      </li>
      <span
        v-if="!isLoggedIn"
        class="AccountNav-auth"
      >
        <li class="AccountNav-login"><a
          href="/login"
          class="Button Button--tertiary Button--small"
        >Log in</a></li>
        <li class="account last signup">
          <a
            href="/register"
            class="Button Button--primary Button--small"
          ><span>Sign Up</span></a>
        </li>
      </span>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import LinearProgressBar from '@/components/common/linear-progress-bar';
import Notifications from '@/components/notifications/notifications.vue';

// TODO: NAMESPACE
export default {
  components: {
    LinearProgressBar,
    Notifications,
  },
  data() {
    return {
      isLoading: true,
      showUserMenu: false,
    };
  },
  computed: {
    ...mapGetters('savedItems', {
      getItemCount: 'getItemCount',
    }),
    ...mapState('user', {
      firstname: (state) => state.firstname,
      isAdmin: (state) => state.isAdmin,
      isLoggedIn: (state) => state.loggedIn,
      profile_completion: (state) => state.profile_completion,
    }),

    isAdminPage() {
      return window.location.pathname.indexOf('admin/') > -1;
    },

    computedCount() {
      if (this.isLoggedIn) {
        if (this.getItemCount > 99) {
          return '99+';
        }
        return this.getItemCount;
      }
      return false;
    },
  },

  mounted() {
    this.isLoading = false;
  },

  methods: {
    ...mapActions('user', {
      logout: 'logOutUser',
    }),

    handleMouseEvent(type) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        this.showUserMenu = type === 'show';
      } else if (type === 'hide') {
        this.showUserMenu = false;
      }
    },

    handleShowMenu() {
      this.$nextTick(() => {
        this.showUserMenu = !this.showUserMenu;
      });
    },

    openPanel() {
      this.$gtag({ event: 'nav-icon', action: 'open-side-panel' });
      this.$bus.$emit('rmp:notifications:open', true);
    },
  },
};
</script>
